import React, { useState } from 'react';
import { DeviceType } from '../../../enum/EnumRepository';
import { useDeviceStore } from '../../../store/deviceStore';
import styled from 'styled-components';
import { paperTextureSmall } from '../../paperTexture';

interface HintWrapperProps {
  children: React.ReactNode;
  content: string;
  content2?: string;
  toLeft?: boolean;
}

const HintWrapper: React.FC<HintWrapperProps> = ({ children, content, content2, toLeft }) => {
  const { deviceType } = useDeviceStore();
  const [isHover, setIsHover] = useState(false);

  if (deviceType === DeviceType.MOBILE) {
    return <>{children}</>;
  }

  return (
    <HintHoverWrapper
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}>
      <HintCard $isHover={isHover} $toLeft={toLeft}>
        {content}
        {content2 && <br />}
        {content2 && content2}
      </HintCard>
      {children}
    </HintHoverWrapper>
  );
}

const HintHoverWrapper = styled.div`
  position: relative;
`;

const HintCard = styled.div<{ $isHover: boolean, $toLeft?: boolean }>`
  position: absolute;
  bottom: clamp(35px, 4vh, 40px);
  ${({ $toLeft }) => $toLeft && 'right: 0;'}
  width: fit-content;
  min-width: 50px;
  max-width: 400px;
  display: flex;
  align-items: center;
  gap: 0.5vw;
  padding: 0.6vw 0.8vw;
  
  ${({ theme }) => theme.typography.Body_04};
  white-space: nowrap;
  ${paperTextureSmall}

  /* Hover animations */
  opacity: ${({ $isHover }) => ($isHover ? 1 : 0)};
  transform: translateY(${({ $isHover }) => ($isHover ? '0' : '20px')});
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: ${({ $isHover }) => ($isHover ? 'auto' : 'none')};
`;

export default HintWrapper;